import { render } from "./ReferenceParametersBlock.vue?vue&type=template&id=0bff0c44&scoped=true"
import script from "./ReferenceParametersBlock.vue?vue&type=script&lang=js"
export * from "./ReferenceParametersBlock.vue?vue&type=script&lang=js"

import "./ReferenceParametersBlock.vue?vue&type=style&index=0&id=0bff0c44&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bff0c44"]])

export default __exports__